import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
// import cookie from '../utils/cookie'

// const Key_Token = "fx_token"
// const Key_Fx = "fxlginfo"
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        footer: true,
        header: true,
        // token: cookie.get(Key_Fx).token || null,
        // user: cookie.get(Key_Fx) || null,
        token: localStorage.getItem('token') || null,
        user: JSON.parse(localStorage.getItem('user')) || null,
        notice: 0,
        showlogin: false,
        ding: null, //订阅弹窗确认(数据)
        dingSuccess: [], //订阅成功
        showMoreFree: parseInt(localStorage.getItem('sfree')) || 0,
        showTreaty: false,
        showMianze: false
    },
    mutations: {
        //更新值
        SHOW_FOOTER(state){
            state.footer = true
        },
        HIDE_FOOTER(state){
            state.footer = false
        },

        SHOW_HEADER(state){
            state.header = true
        },
        HIDE_HEADER(state){
            state.header = false
        },

        SET_DING(state, data){
            state.ding = data
        },
        CLOSE_DING(state){
            state.ding = null
        },

        SHOW_LOGINPOP(state){
            state.showlogin = true
        },
        HIDE_LOGINPOP(state){
            state.showlogin = false
        },

        SET_NOTICE(state, notice){
            state.notice = notice
        },

        SET_DINGYUE(state, value){
            // value = parseInt(value)
            let list = state.dingSuccess
            // if(list.indexOf(value)===-1)
                list.push(value)
            state.dingSuccess = list
            //state.dingSuccess = value
        },

        LOGIN(state, token) {
            state.token = token
            //cookie.set(Key_Fx, info, expires_time)
            localStorage.setItem('token', token)
        },
        LOGOUT(state) {
            state.token = null
            state.user = null
            // cookie.remove(Key_Fx)
            localStorage.removeItem('token')
            localStorage.removeItem('user')
        },

        SET_USER(state, user){
            state.user = user
            // Vue.set(state, 'user', user)
            // cookie.set(Key_Fx, info, expires_time)
            // cookie.update(Key_Fx, info)
            localStorage.setItem('user', JSON.stringify(user))
        },

        setShowMoreFree(state, v){
            state.showMoreFree = v
            localStorage.setItem('sfree', v)
        },

        SHOW_TREATY(state){
            state.showTreaty = true
        },
        HIDE_TREATY(state){
            state.showTreaty = false
        },

        SHOW_MIANZE(state){
            state.showMianze = true
        },
        HIDE_MIANZE(state){
            state.showMianze = false
        },
    },
    getters
})
